import { IntegrationProvider } from 'models'

/**
 * The icon of each integration provider, written out rather than derived.
 *
 * Interpolating `mdi:${provider}` worked while the providers were `hubspot`
 * and `salesforce`, and breaks on the first one whose icon is not named after
 * it: SharePoint's is `mdi:microsoft-sharepoint`. A missing icon is not an
 * error anyone sees, it is an empty square in the corner of a card, so the map
 * is explicit and every new provider has to add its line.
 *
 * Used by the card in Integrations and by the document rows that show where a
 * document came from, which is why it lives next to the component instead of
 * inside it.
 */
const PROVIDER_ICONS: Record<IntegrationProvider, string> = {
    [IntegrationProvider.HubSpot]: 'mdi:hubspot',
    [IntegrationProvider.Salesforce]: 'mdi:salesforce',
    [IntegrationProvider.SharePoint]: 'mdi:microsoft-sharepoint',
}

/** Fallback for a provider added to the enum and forgotten here. */
const FALLBACK_ICON = 'mdi:puzzle-outline'

export function integrationProviderIcon(
    provider?: IntegrationProvider | string,
): string {
    if (!provider) {
        return FALLBACK_ICON
    }
    return PROVIDER_ICONS[provider as IntegrationProvider] ?? FALLBACK_ICON
}
